// src/pages/premium/Interview.jsx
import React from "react";

export default function Interview() {
  return (
    <div className="container mt-5 text-center">
      <h2>🎤 UPSC Interview</h2>
      <p>Interview guidance content here.</p>
    </div>
  );
}